import React from 'react'
import { Row, Col } from 'react-bootstrap'
import './style.scss'

const DashboardLayout = ({DashboardLeftNavigation, DashboardUpperNavigation, DashboardContent}) => {
    return(
        <section className="full-dashboard-section">
            <Row className="full-dashboard-row">
                <Col className="dashboard-navigation-left-col">
                    {DashboardLeftNavigation ? <DashboardLeftNavigation/>:null}
                </Col>
                <Col className="dashboard-content-col">
                    <Row className="dashboard-navigation-top-row">
                        <Col className="dashboard-navigation-top-col">
                            {DashboardUpperNavigation ? <DashboardUpperNavigation/>:null}
                        </Col>
                    </Row>
                    <Row className="dashboard-content-row">
                        <Col className="dashboard-content-col">
                            {DashboardContent ? <DashboardContent/>:null}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </section>
    )
}

export default DashboardLayout